/**
 * Which routes are flat forest rather than paper. The RSVP flow is — `Surface`
 * paints the document itself from this, so a phone's status bar matches the
 * page rather than framing it in a pale band.
 *
 * `/rsvp` exactly, not the path and everything under it: there are no bespoke
 * invitation links any more, so a deeper path is a stale one and gets the
 * ordinary paper "this page has drifted".
 */
export function isForestRoute(path: string): boolean {
  return path === '/rsvp';
}
